import contentDisposition from "content-disposition";
import createHttpClient from "./createClient";

const _omit = (arr, key) => {
  // eslint-disable-next-line no-unused-vars
  const { [key]: value, ...res } = arr;
  return res;
};

const httpClient = createHttpClient();

class HydraClient {
  constructor(collectionUrl) {
    this.collectionUrl = collectionUrl;
  }

  fetchEntity = (entityUrl, config = {}) => {
    const sendGetRequest = httpClient.get(entityUrl, config);

    return sendGetRequest;
  };

  fetchEntityList = (config = {}) => {
    let sendGetRequest;

    if (config.params && (config.params.pagination === false || config.params.page !== undefined)) {
      sendGetRequest = httpClient.get(config.url || this.collectionUrl, config);
    } else {
      let _responses = [];

      const handleResponse = response => {
        _responses.push(response);

        if (response.data["hydra:view"] && response.data["hydra:view"]["hydra:next"]) {
          return httpClient
            .get(response.data["hydra:view"]["hydra:next"], _omit(config, "params"))
            .then(handleResponse);
        } else {
          return _responses;
        }
      };

      const mergeResponses = responses => {
        const mergedResponse = { ...responses[0] };
        const hydraView = responses[0].data["hydra:view"];

        mergedResponse.data["hydra:view"] = hydraView && {
          "@id": hydraView["@id"],
          "@type": hydraView["@type"]
        };

        mergedResponse.data["hydra:member"] = responses.reduce(
          (hydraMember, response) => hydraMember.concat(response.data["hydra:member"]),
          []
        );

        return mergedResponse;
      };

      sendGetRequest = httpClient
        .get(config.url || this.collectionUrl, config)
        .then(handleResponse)
        .then(mergeResponses);
    }

    return sendGetRequest;
  };

  fetchEntityFile = (entityUrl, fileType, config = {}) => (dispatch, getState) => {
    const sendGetRequest = httpClient.request({
      method: "GET",
      url: `${entityUrl}/${fileType}`,
      responseType: "arraybuffer",
      ...config
    });

    const receiveFile = response => {
      let name = "";
      const contentDispositionParameters = contentDisposition.parse(response.headers["content-disposition"]).parameters;

      if (contentDispositionParameters && contentDispositionParameters.filename) {
        name = contentDispositionParameters.filename;
      }

      return {
        type: response.headers["content-type"], // https://developer.mozilla.org/en-US/docs/Web/API/Blob/type
        name, // https://developer.mozilla.org/en-US/docs/Web/API/File/name
        content: response.data // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsArrayBuffer
      };
    };

    return sendGetRequest.then(receiveFile);
  };

  saveEntity = (entityUrl = null, data = {}, config = {}) => {
    const sendSaveRequest = httpClient.request({
      method: entityUrl ? "PUT" : "POST",
      url: entityUrl || this.collectionUrl,
      data,
      ...config
    });

    return sendSaveRequest;
  };

  saveEntityTransition = (entityUrl, transition, config = {}) => {
    const sendSaveRequest = httpClient.post(`${entityUrl}/transitions`, { transition }, config);

    return sendSaveRequest;
  };

  saveEntityTransfer = (entityUrl, data = {}, config = {}) => {
    const sendSaveRequest = httpClient.post(`${entityUrl}/transfer`, data, config);

    return sendSaveRequest;
  };

  deleteEntity = (entityUrl, config = {}) => {
    const sendDeleteRequest = httpClient.delete(entityUrl, config);

    return sendDeleteRequest;
  };
}

export default HydraClient;



// WEBPACK FOOTER //
// ./src/shadow-client/axios/HydraClient.js